import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { mosaicCardMotion } from './motion';
import { mosaicChromeTone } from './palette';

export const mosaicTheme: FlowThemeDefinition = {
  id: 'mosaic',
  label: 'Mosaic',
  description: 'A sun-and-lotus mosaic is laid wedge by wedge in glass and gold, until the finished wall lights up and scatters coloured light.',
  category: 'playful',
  chromeTone: mosaicChromeTone,
  swatch: 'conic-gradient(from 0deg at 50% 50%, #F2B632, #D9622B, #B8283A, #3FA7A0, #1F3D8F, #1B1F4A, #F2B632)',
  cardGlass: 'dense',
  cardMotion: mosaicCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createMosaicScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
